import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import Cookie from 'js-cookie';
import Evercookie from '../lib/evercookie';
import { randomString } from '../helper/utils/common';
/**
 * 获取随机数
 * @returns string
 */

export var getLocalCache = function getLocalCache() {
  return new _Promise(function (resolve, reject) {
    var str = '',
        newStr,
        cookieStr,
        locolStr,
        name = '.thumbcache_al'; //校验

    var re = /^[0-9A-Z]*$/g,
        numRe = /^[0-9]*$/g; ///^[0-9A-Z]\w{0,61}$/g

    var time;
    time = window.performance.now();

    try {
      var ec = new Evercookie({
        history: false,
        tests: 1 // silverlight: false,
        // java: false,

      });
      ec.get(name, function (value, all_candidates) {
        if (value && value.length === 68 && re.test(value.slice(0, 61)) && numRe.test(value.slice(62, value.length))) {
          resolve(value);
        } else {
          str = randomString(62, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789') + _parseInt(Math.random() * 1000000);
          ec.set(name, str);
          resolve(str);
        }
      });
    } catch (e) {
      try {
        cookieStr = Cookie.get(name) || undefined;
        locolStr = localStorage.getItem(name) || undefined;
        if (cookieStr === locolStr && cookieStr !== undefined && cookieStr.length > 62 && re.test(cookieStr.slice(0, 61)) && numRe.test(cookieStr.slice(62, cookieStr.length))) str = cookieStr;else {
          str = randomString(62, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789') + _parseInt(Math.random() * 1000000);
        }
        Cookie.set(name, str, {
          expires: 365 * 2,
          path: ''
        });
        localStorage.setItem(name, str);
      } catch (e) {}

      resolve(str);
    }
  }).catch(function (e) {// console.log(e)
  });
};